import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { internalCustomerException } from "../../customer/utils/customerQueryHelpers"
import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getEmployeeReference } from "../../shared/utils/getEmployeeReference"

export const mutationDeleteNote = {
  async deleteNote(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args
    const { user } = context

    if (!id) return null

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    try {
      const draftsFilter = `&& !(_id in path("drafts.**"))`
      // make sure note exists and the id is actually of type note
      const note = await client.fetch(groq`*[_type=="note" && _id==$id ${draftsFilter}][0] {...}`, {
        id: id,
      })

      if (!note) return null

      await Promise.all([
        checkPermissions({
          user,
          domainObject: DomainObjects.NOTES,
          operation: Operations.DELETE,
        }),
        validateAccessRightsToCustomer({ user, customerNumber: note.customerNumber }),
        internalCustomerException({ customerNumber: note.customerNumber }),
      ])

      const modifiedBy = await getEmployeeReference({
        employeeNumber: user.employeeNumber,
        sanityClient: client,
      })

      const updatedValues = {
        ...note,
        status: "X",
        modifiedAt: new Date().toISOString(),
        modificationSource: "Sanity",
        ...(modifiedBy && { modifiedBy }),
      }

      const deleteNote = await client.patch(id).set(updatedValues).commit()

      if (!deleteNote) return null

      return true
    } catch (error) {
      console.warn("Error deleting note", error)
      return null
    }
  },
}
